// extracted by mini-css-extract-plugin
export default {"error_msg":"Errormsg_error_msg__-HwSh"};